export const cc = {
  navy: "#061f36",
  navy2: "#082b4f",
  blue: "#0d6efd",
  green: "#22a652",
  orange: "#f97316",
  amber: "#f5b400",
  red: "#ff3b30",
  purple: "#6d28d9",
  ink: "#12213a",
  muted: "#5d6b82",
  line: "#dbe5f1",
  panel: "#ffffff",
  page: "#f5f8fc",
};

// Semantic status tokens (Portal asset grid). Reuse the raw colours above.
cc.safety = { green: cc.green, amber: cc.amber, red: cc.red, unknown: cc.muted };
cc.workflowState = {
  done: cc.green,
  active: cc.blue,
  escalated: cc.red,
  blocked: cc.muted,
  pending: "#eaf1f8",
  overdue: cc.orange,
};

export const isAfmsPath = (pathname = "") => pathname === "/afms" || pathname.startsWith("/afms/");

export const panelSx = {
  border: `1px solid ${cc.line}`,
  borderRadius: "12px",
  boxShadow: "0 10px 30px rgba(15, 39, 78, 0.06)",
  bgcolor: cc.panel,
};

export const tableContainerSx = {
  boxShadow: "none",
  border: `1px solid ${cc.line}`,
  borderRadius: "10px",
  bgcolor: cc.panel,
  overflowX: "auto",
};

export const nativeSelectSx = {
  ".c-select-wrapper": {
    position: "relative",
    width: "100%",
  },
  ".c-select": {
    width: "100%",
    minHeight: 38,
    borderRadius: "8px",
    border: `1px solid ${cc.line}`,
    backgroundColor: "#fff",
    color: cc.ink,
    fontSize: 13,
    fontWeight: 600,
    padding: "8px 34px 8px 12px",
    outline: "none",
    appearance: "none",
    backgroundImage:
      "linear-gradient(45deg, transparent 50%, #5d6b82 50%), linear-gradient(135deg, #5d6b82 50%, transparent 50%)",
    backgroundPosition: "calc(100% - 16px) 50%, calc(100% - 11px) 50%",
    backgroundSize: "5px 5px, 5px 5px",
    backgroundRepeat: "no-repeat",
  },
  ".c-select:focus": {
    borderColor: cc.blue,
    boxShadow: "0 0 0 3px rgba(13, 110, 253, 0.14)",
  },
  ".c-select:disabled": {
    color: cc.muted,
    backgroundColor: "#eef3f8",
    cursor: "not-allowed",
  },
};

export const afmsWorkspaceSx = {
  minHeight: "100vh",
  bgcolor: cc.page,
  color: cc.ink,
  ...nativeSelectSx,
  "& a": {
    color: cc.blue,
  },
  "& .MuiCard-root": {
    ...panelSx,
    backgroundImage: "none",
    color: cc.ink,
  },
  "& .MuiPaper-root:not(.MuiDrawer-paper):not(.MuiMenu-paper):not(.MuiPopover-paper)": {
    backgroundImage: "none",
  },
  "& .MuiTableContainer-root": tableContainerSx,
  "& .MuiTableCell-head": {
    bgcolor: "#f8fbff",
    color: cc.muted,
    fontSize: 11,
    fontWeight: 800,
    textTransform: "uppercase",
    borderBottom: `1px solid ${cc.line}`,
  },
  "& .MuiTableCell-body": {
    color: cc.ink,
    borderBottom: `1px solid ${cc.line}`,
  },
  "& .MuiTabs-indicator": {
    backgroundColor: cc.blue,
  },
  "& .MuiTab-root": {
    color: cc.muted,
    fontWeight: 700,
    textTransform: "none",
  },
  "& .MuiTab-root.Mui-selected": {
    color: cc.blue,
  },
  "& .MuiDivider-root": {
    borderColor: cc.line,
  },
  "& .MuiSkeleton-root": {
    bgcolor: "rgba(93, 107, 130, 0.14)",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: cc.panel,
    color: cc.ink,
    "& fieldset": {
      borderColor: cc.line,
    },
    "&:hover fieldset": {
      borderColor: "#b8c7d9",
    },
    "&.Mui-focused fieldset": {
      borderColor: cc.blue,
      boxShadow: "0 0 0 3px rgba(13, 110, 253, 0.14)",
    },
  },
  "& .MuiInputBase-input": {
    color: cc.ink,
  },
  "& .MuiInputLabel-root": {
    color: cc.muted,
  },
  "& .MuiButton-root": {
    borderRadius: "8px",
    textTransform: "none",
    letterSpacing: 0,
  },
  "& .MuiButton-containedPrimary, & .MuiButton-containedInfo": {
    backgroundColor: cc.blue,
    boxShadow: "0 10px 18px rgba(13, 110, 253, 0.18)",
    color: "#fff",
    "&:hover": {
      backgroundColor: cc.blue,
      boxShadow: "0 12px 22px rgba(13, 110, 253, 0.22)",
    },
  },
  "& .MuiButton-outlinedPrimary, & .MuiButton-outlinedInfo": {
    borderColor: "rgba(13, 110, 253, 0.38)",
    color: cc.blue,
    "&:hover": {
      borderColor: cc.blue,
      backgroundColor: "rgba(13, 110, 253, 0.07)",
    },
  },
  "& .MuiButton-containedSuccess": {
    backgroundColor: cc.green,
    color: "#fff",
  },
  "& .MuiButton-containedWarning": {
    backgroundColor: cc.orange,
    color: "#fff",
  },
  "& .MuiButton-containedError": {
    backgroundColor: cc.red,
    color: "#fff",
  },
  "& .MuiSvgIcon-colorPrimary, & .MuiSvgIcon-colorInfo": {
    color: cc.blue,
  },
  "& .MuiSvgIcon-colorSuccess": {
    color: cc.green,
  },
  "& .MuiSvgIcon-colorWarning": {
    color: cc.orange,
  },
  "& .MuiSvgIcon-colorError": {
    color: cc.red,
  },
  "& .MuiChip-root": {
    borderRadius: "999px",
    fontWeight: 700,
  },
  "& .MuiChip-colorPrimary, & .MuiChip-colorInfo": {
    backgroundColor: cc.blue,
    color: "#fff",
  },
  "& .MuiChip-colorSuccess": {
    backgroundColor: cc.green,
    color: "#fff",
  },
  "& .MuiChip-colorWarning": {
    backgroundColor: cc.orange,
    color: "#fff",
  },
  "& .MuiChip-colorError": {
    backgroundColor: cc.red,
    color: "#fff",
  },
  "& .MuiChip-outlinedPrimary, & .MuiChip-outlinedInfo": {
    backgroundColor: "transparent",
    borderColor: cc.blue,
    color: cc.blue,
  },
  "& .MuiChip-outlinedSuccess": {
    backgroundColor: "transparent",
    borderColor: cc.green,
    color: cc.green,
  },
  "& .MuiChip-outlinedWarning": {
    backgroundColor: "transparent",
    borderColor: cc.orange,
    color: cc.orange,
  },
  "& .MuiChip-outlinedError": {
    backgroundColor: "transparent",
    borderColor: cc.red,
    color: cc.red,
  },
  "& .k-button-solid-primary, & .k-button-solid-base.k-selected": {
    backgroundColor: cc.blue,
    borderColor: cc.blue,
    color: "#fff",
  },
  "& .k-button": {
    borderRadius: "8px",
    fontWeight: 700,
  },
  "& .k-input, & .k-picker, & .k-dropdownlist": {
    borderColor: cc.line,
    borderRadius: "8px",
    color: cc.ink,
    backgroundColor: cc.panel,
  },
};

export const afmsDashboardLayoutSx = (theme, miniSidenav) => {
  const { breakpoints, transitions, functions } = theme;
  const { pxToRem } = functions;

  return {
    ...afmsWorkspaceSx,
    p: { xs: 2, md: 3 },
    position: "relative",
    overflowX: "hidden",
    [breakpoints.up("xl")]: {
      marginLeft: miniSidenav ? pxToRem(96) : pxToRem(280),
      transition: transitions.create(["margin-left", "margin-right"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
  };
};

export const afmsNavbarSx = {
  position: "sticky",
  top: 12,
  zIndex: 20,
  minHeight: 72,
  display: "grid",
  alignItems: "center",
  bgcolor: `${cc.panel} !important`,
  color: cc.ink,
  border: `1px solid ${cc.line}`,
  borderRadius: "12px",
  boxShadow: "0 10px 30px rgba(15, 39, 78, 0.06)",
  backgroundImage: "none",
  backdropFilter: "none",
  px: { xs: 0.5, md: 1 },
  py: 0.75,
  "& .MuiToolbar-root": {
    minHeight: "auto",
  },
  "& .MuiBreadcrumbs-separator": {
    color: cc.muted,
  },
  "& .MuiTypography-root": {
    color: cc.ink,
  },
  "& .MuiTypography-caption, & .MuiTypography-button": {
    color: cc.muted,
  },
};

export const afmsNavbarContainerSx = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: { xs: "flex-start", md: "center" },
  justifyContent: "space-between",
  gap: { xs: 1.25, md: 2 },
  width: "100%",
  px: { xs: 1.5, md: 2 },
  py: { xs: 1, md: 1.25 },
};

export const toneColor = {
  info: cc.blue,
  primary: cc.blue,
  success: cc.green,
  warning: cc.orange,
  error: cc.red,
  secondary: cc.muted,
  dark: cc.ink,
};

export const toneHex = (tone = "info") => toneColor[tone] || cc.blue;

export const toneRgba = (tone = "info", alpha = 0.12) => {
  const color = toneHex(tone).replace("#", "");
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const buttonSx = (tone = "info") => {
  const color = toneHex(tone);

  return {
    background: color,
    color: "#fff",
    boxShadow: `0 10px 18px ${color}2e`,
    "&:hover": {
      background: color,
      boxShadow: `0 12px 22px ${color}38`,
      color: "#fff",
    },
    "&.Mui-disabled": {
      background: "#c8d4e3",
      color: "#fff",
    },
  };
};

export const outlinedButtonSx = (tone = "info") => {
  const color = toneHex(tone);

  return {
    borderColor: `${color}66`,
    color,
    background: "#fff",
    "&:hover": {
      borderColor: color,
      background: `${color}12`,
      color,
    },
  };
};

export const ccModalStyles = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92vw", sm: 460 },
    maxWidth: "92vw",
    maxHeight: "92vh",
    bgcolor: cc.panel,
    color: cc.ink,
    border: `1px solid ${cc.line}`,
    borderRadius: "12px",
    boxShadow: "0 24px 70px rgba(6, 31, 54, 0.24)",
    p: { xs: 2.25, sm: 3 },
    // Flex-column so the title pins at the top, the optional scrollBody
    // child takes the remaining space and scrolls, and the action row
    // pins at the bottom. Replaces the old container-level overflowY:auto
    // which scrolled the close button out of reach on short viewports.
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    ...nativeSelectSx,
  },
  // Opt-in wrapper for the body region between the title and the
  // action buttons. Use on any modal whose body can grow taller than
  // the viewport (forms, lists, tables).
  scrollBody: {
    flex: "1 1 auto",
    minHeight: 0,
    overflowY: "auto",
    mt: 2,
  },
  title: {
    margin: 0,
    fontSize: "18px",
    lineHeight: 1.3,
    color: cc.ink,
    fontWeight: 800,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
};
